import Swiper from 'swiper/bundle';

const swiperContainers = {
    thumbs: ".thumbs-slider.swiper-container",
    hero: ".hero-slider.swiper-container",
};

let swiper1;
let swiper2;

if ($(swiperContainers.thumbs).length > 0) {
    swiper1 = new Swiper(swiperContainers.thumbs, {
        spaceBetween: 16,
        slidesPerView: 1,
        slideToClickedSlide: true,
        loop: false,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 24,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
            1920: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
      
    });
}

if ($(swiperContainers.hero).length > 0) {
    swiper2 = new Swiper(swiperContainers.hero, {
        loop: true,
        effect: 'fade',
        slidesPerView: 1,
        updateOnWindowResize: true,
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true,
        },
        thumbs: {
            swiper: swiper1,
        },
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        navigation: {
            nextEl: ".swiper-button-next.hero-swiper-button",
            prevEl: ".swiper-button-prev.hero-swiper-button",
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                $(".progress-inner").css("width", (1 - progress) * 100 + "%");
            },
 
            slideChangeTransitionEnd(swiper) {
                const activeSlide = swiper.slides[swiper.activeIndex];
                
                const id = activeSlide && activeSlide.querySelector('.media-box').getAttribute('data-id') || 0
                id &&  document.dispatchEvent(new CustomEvent("slideChangeVideoSlider", {
                    detail: {
                        active: id,
                        swiper: swiper
                    }
                }));
            }
        },
    });
}